import React from 'react';
import clsx from 'clsx';

const variants = {
  primary: 'bg-emerald-500 hover:bg-emerald-600 text-white',
  secondary: 'bg-bg-tertiary hover:bg-border text-text-primary border border-border',
  ghost: 'hover:bg-bg-tertiary text-text-secondary hover:text-text-primary',
  // Text-only button for tertiary actions
  text: 'text-text-secondary hover:text-text-primary hover:underline underline-offset-2',
  // Outline button for secondary actions
  outline: 'border border-border text-text-secondary hover:border-text-muted hover:text-text-primary bg-transparent',
  danger: 'bg-loss hover:bg-loss/80 text-white',
  warning: 'text-amber-500 hover:text-amber-400 hover:underline underline-offset-2',
  profit: 'bg-profit hover:bg-profit/80 text-white',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  loading,
  leftIcon,
  rightIcon,
  ...props
}) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <>
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2" />
          Loading...
        </>
      ) : (
        <>
          {leftIcon && <span className="mr-2">{leftIcon}</span>}
          {children}
          {rightIcon && <span className="ml-2">{rightIcon}</span>}
        </>
      )}
    </button>
  );
}
